import React from 'react';
import dayjs from 'dayjs';

import styles from './ZtList.module.less';
import Header from '../Header';
import GameLink from '../GameLink';

const handleNumber = (datas = 0) => {
  if (isNaN(+datas)) {
    return datas;
  }
  if (+datas < 1000) {
    return datas;
  }
  if (+datas < 10000) {
    return `${(datas / 1000).toFixed(1)}k`;
  }

  return `${(datas / 10000).toFixed(1)}w`;
};

export default ({ title, operate, to, tag: source, data = [] }) => {
  return (
    <div className={styles.ZtList}>
      <Header
        title={title}
        operate={operate === '2' ? '2' : '0'}
        to={to}
        source={source}
      />
      <nav>
        {
          data
            .map(zt => {
              return (
                <GameLink
                  key={zt.ztId}
                  info={zt}
                  source={source}
                  logInfo={{
                    category: 'C',
                    action: 'Game_Non_Button',
                    params: {
                      id: zt.ztId || '',
                      type: 'zt',
                      source,
                    },
                    bizInfo: zt.bizInfo,
                  }}>
                  <header>
                    <b style={{backgroundImage: `url("${zt.contentImg}")`}}></b>
                  </header>
                  <section>
                    <h1 title={zt.contentTitle}>{zt.contentTitle}</h1>
                    <p>
                      <span>{(zt.pushTime && dayjs(zt.pushTime).format('YYYY/MM/DD')) || ''}</span>
                      <span><i className="iconfont icon-reads" />{handleNumber(zt.watchCount || 0)}&ensp;<i className="iconfont icon-zan" />{handleNumber(zt.zanCount || 0)}</span>
                    </p>
                  </section>
                </GameLink>
              )
            })
        }
      </nav>
    </div>
  );
};
